<template>
    <header class="header-top navbar navbar-light navbar-expand-md">
        <button
            class="k-navbar__toggler-icon navbar-toggler d-sm-none collapsed"
            :class="{ active: isMenuOpened }"
            @click="toggleMenu"
        >
            <span></span>
        </button>

        <router-link :to="{ name: 'ReceipesRegular' }" @click.native="$emit('close')" class="header-logo navbar-brand">
            <img class="header-logo__img" src="/img/logo.svg" alt="logo">
            <!-- <img class="header-logo__img" src="/img/logo-ny.png" alt="logo"> -->
        </router-link>

        <div v-if="getUser && false" class="header-notifications">
            <span class="header-notifications__badge badge badge-warning">3</span>
            <svg class="header-notifications__icon" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.2287 22.6703C23.3153 22.0435 22.7971 19.9177 22.7022 18.3077V12.9231C22.7022 9.17323 20.2542 5.97908 16.844 4.79985C17.108 4.33354 17.2727 3.80262 17.2727 3.23077C17.2727 1.44954 15.8044 0 14 0C12.1956 0 10.7273 1.44954 10.7273 3.23077C10.7273 3.79831 10.8887 4.32385 11.1505 4.788C7.736 5.95862 5.27273 9.16246 5.27273 12.9231L5.27491 18.2452C5.17673 19.9177 4.65964 22.0425 2.74618 22.6692C2.30873 22.8135 2 23.2723 2 23.6923C2 24.2825 2.624 24.7692 3.09091 24.7692H9.79127C10.2789 26.6226 11.972 28 14 28C16.028 28 17.7211 26.6226 18.2087 24.7692H24.9091C25.4818 24.7692 26 24.2534 26 23.6923C26 23.2174 25.6847 22.8275 25.2287 22.6703ZM14 2.15385C14.6022 2.15385 15.0909 2.63631 15.0909 3.23077C15.0909 3.82523 14.6022 4.30769 14 4.30769C13.3978 4.30769 12.9091 3.82523 12.9091 3.23077C12.9091 2.63631 13.3978 2.15385 14 2.15385ZM7.45455 12.9231C7.45455 9.37031 10.3815 6.47231 13.9967 6.46154C17.5935 6.47231 20.5193 9.37031 20.5193 12.9231L20.5215 18.3702C20.6218 20.0943 21.0647 21.5234 21.8 22.6154H10.7273H6.16836C6.90691 21.5148 7.35309 20.0674 7.45455 18.3077V12.9231ZM14 25.8462C13.196 25.8462 12.5 25.41 12.1215 24.7692H15.8775C15.5 25.41 14.804 25.8462 14 25.8462Z" fill="#808080"/>
            </svg>
        </div>
        <div v-if="getUser" class="header-user d-none d-lg-flex">
            <div class="header-user__content"  data-toggle="dropdown" id="userMenuDropdownButton" role="navigation" data-target="header__user-dropdown-menu">
                <div class="header-user__avatar">
                    <img  class="header-user__avatar-img" :src="getCurrentProfile.avatar_url" v-if="getCurrentProfile && typeof getCurrentProfile.avatar_url !== 'undefined'" />
                    <div class="header-user__no-avatar" v-else>{{getUser.name[0]}}</div>
                </div>
                <div class="header-user__name">{{getUser.name}}</div>

                <div class="dropdown header-user__dropdown">
                    <a class="" href="#">
                        <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6625 0.223756L8 6.98619L1.33754 0.223757C1.0347 -0.074585 0.529968 -0.074585 0.227129 0.223757C-0.0757102 0.522099 -0.0757101 1.01934 0.227129 1.41713L7.39432 8.77624C7.69716 9.07459 8.20189 9.07459 8.50473 8.77624L15.7729 1.51657C16.0757 1.21823 16.0757 0.720994 15.7729 0.323204C15.47 -0.0745856 14.9653 -0.0745856 14.6625 0.223756Z" fill="#fff"/>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="dropdown-menu dropdown-menu-right header__user-dropdown-menu">
                <router-link v-if="getCurrentProfile && getCurrentProfile.id" to="/profile" class="dropdown-item ">
                    <svg class="header__dropdown-menu-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0)">
                            <path d="M19.0602 0.959122C17.791 -0.253301 15.793 -0.253301 14.5238 0.959122L1.29091 14.1912C1.22003 14.2621 1.1703 14.3514 1.14778 14.4491L0.0136789 19.3644C-0.0229366 19.5232 0.0148537 19.69 0.11628 19.8175C0.217707 19.9449 0.371805 20.0193 0.534715 20.0191C0.575246 20.0193 0.615386 20.0148 0.654743 20.0056L5.57022 18.8715C5.66793 18.849 5.75721 18.7995 5.8281 18.7286L19.0602 5.49592C20.3133 4.24335 20.3133 2.21188 19.0602 0.959122ZM5.45019 17.5945L2.42482 14.5691L13.7676 3.22732L16.792 6.25212L5.45019 17.5945ZM1.9729 15.6294L4.38971 18.046L1.24803 18.7713L1.9729 15.6294ZM18.3042 4.73992L17.5482 5.49592L14.5238 2.47132L15.2798 1.71532C16.1258 0.907038 17.4581 0.907038 18.3042 1.71532C19.1395 2.55043 19.1395 3.90481 18.3042 4.73992Z"
                                  fill="#666666" fill-opacity="0.6"/>
                        </g>
                        <defs>
                            <clipPath id="clip0">
                                <rect width="20" height="20" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    Редактировать профиль
                </router-link>
                <!--
                <router-link v-if="getCurrentProfile && getCurrentProfile.id" class="dropdown-item " to="/subscribes">
                    <svg class="header__dropdown-menu-icon" width="22" height="19" viewBox="0 0 22 19" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.9513 11.4473C16.5624 11.4473 16.2474 11.7623 16.2474 12.1512V16.395C16.2474 16.8476 15.879 17.2164 15.426 17.2164H6.57346C6.12085 17.2164 5.7521 16.848 5.7521 16.395V12.1512C5.7521 11.7623 5.43711 11.4473 5.04817 11.4473C4.65923 11.4473 4.34424 11.7623 4.34424 12.1512V16.395C4.34424 17.6244 5.34409 18.6243 6.57346 18.6243H15.426C16.6554 18.6243 17.6552 17.6244 17.6552 16.395V12.1512C17.6552 11.7623 17.3402 11.4473 16.9513 11.4473Z"
                              fill="#666666" fill-opacity="0.6"/>
                        <path d="M17.7978 2.75854C17.2 2.75854 16.6003 2.89032 16.0644 3.13033C15.1175 1.23135 13.1681 0 10.9998 0C8.82624 0 6.8806 1.22968 5.93455 3.13008C5.39883 2.89023 4.79931 2.75854 4.20181 2.75854C1.88454 2.75854 0 4.64343 0 6.96C0 9.27658 1.88454 11.1615 4.20185 11.1615C4.84705 11.1615 5.4934 11.0101 6.07226 10.7233C6.42081 10.5506 6.56303 10.1285 6.39065 9.77994C6.21792 9.43178 5.79465 9.28995 5.44726 9.4619C5.05638 9.6556 4.63771 9.75361 4.20185 9.75361C2.6613 9.75361 1.40786 8.50055 1.40786 6.96C1.40786 5.41946 2.6613 4.1664 4.20185 4.1664C4.8055 4.1664 5.4061 4.36242 5.84995 4.7041C6.15806 4.94089 6.60003 4.8837 6.8372 4.57558C6.89414 4.50163 6.93362 4.41991 6.95717 4.33527C6.95867 4.33105 6.96048 4.32706 6.9619 4.32276C7.53809 2.57932 9.16061 1.40825 11.0002 1.40825C12.8248 1.40825 14.4436 2.56751 15.0281 4.29264C15.0308 4.30038 15.0342 4.30755 15.037 4.31511C15.0597 4.40698 15.1009 4.49579 15.1624 4.57558C15.3992 4.8837 15.8411 4.94089 16.1496 4.7041C16.5935 4.36242 17.1941 4.1664 17.7977 4.1664C19.3387 4.1664 20.5921 5.41946 20.5921 6.96C20.5921 8.50055 19.3387 9.75361 17.7977 9.75361C17.3622 9.75361 16.9431 9.6556 16.5523 9.4619C16.2034 9.28956 15.7817 9.43178 15.6089 9.78033C15.4366 10.1289 15.5788 10.551 15.9274 10.7237C16.5142 11.0139 17.1434 11.1615 17.7974 11.1615C20.1143 11.1615 22 9.27658 22 6.96C22 4.64343 20.1147 2.75854 17.7978 2.75854Z"
                              fill="#666666" fill-opacity="0.6"/>
                        <path d="M11.0008 11.3165C12.5749 11.3165 14.0907 10.6518 15.1603 9.49292C15.4242 9.20692 15.4063 8.76152 15.1207 8.498C14.8347 8.23486 14.3893 8.25205 14.1262 8.53804C13.3223 9.40939 12.1833 9.90893 11.0012 9.90893C9.74162 9.90893 8.55302 9.35331 7.74004 8.38473C7.4895 8.08615 7.04526 8.04765 6.74823 8.29781C6.45004 8.54797 6.4115 8.99183 6.66131 9.28968C7.7424 10.5779 9.32415 11.3165 11.0008 11.3165Z"
                              fill="#666666" fill-opacity="0.6"/>
                    </svg>
                    Подписки
                </router-link>
                -->
                <div class="dropdown-item" @click="$emit('video')" style="cursor: pointer">
                  <svg class="header__dropdown-menu-icon" xmlns="http://www.w3.org/2000/svg" fill="none" style="width:21px;height:21px" viewBox="0 0 24 24">
                    <path fill="#666666" d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z"
                          fill-opacity="0.6" />
                  </svg>
                  Как пользоваться
                </div>
                <a class="dropdown-item" href="https://online-kitchen.ru/faq">
                  <svg class="header__dropdown-menu-icon" xmlns="http://www.w3.org/2000/svg" fill="none" style="width:21px;height:21px" viewBox="0 0 24 24">
                    <path fill="#666666" d="M18.72,14.76C19.07,13.91 19.26,13 19.26,12C19.26,11.28 19.15,10.59 18.96,9.95C18.31,10.1 17.63,10.18 16.92,10.18C13.86,10.18 11.15,8.67 9.5,6.34C8.61,8.5 6.91,10.26 4.77,11.22C4.73,11.47 4.73,11.74 4.73,12A7.27,7.27 0 0,0 12,19.27C13.05,19.27 14.06,19.04 14.97,18.63C15.54,19.72 15.8,20.26 15.78,20.26C14.14,20.81 12.87,21.08 12,21.08C9.58,21.08 7.27,20.13 5.57,18.42C4.53,17.38 3.76,16.11 3.33,14.73H2V10.18H3.09C3.93,6.04 7.6,2.92 12,2.92C14.4,2.92 16.71,3.87 18.42,5.58C19.69,6.84 20.54,8.45 20.89,10.18H22V14.67H22V14.69L22,14.73H21.94L18.38,18L13.08,17.4V15.73H17.91L18.72,14.76M9.27,11.77C9.57,11.77 9.86,11.89 10.07,12.11C10.28,12.32 10.4,12.61 10.4,12.91C10.4,13.21 10.28,13.5 10.07,13.71C9.86,13.92 9.57,14.04 9.27,14.04C8.64,14.04 8.13,13.54 8.13,12.91C8.13,12.28 8.64,11.77 9.27,11.77M14.72,11.77C15.35,11.77 15.85,12.28 15.85,12.91C15.85,13.54 15.35,14.04 14.72,14.04C14.09,14.04 13.58,13.54 13.58,12.91A1.14,1.14 0 0,1 14.72,11.77Z"
                          fill-opacity="0.6" />
                  </svg>
                  Написать в поддержку
                </a>
                <a class="dropdown-item" href="#" @click.prevent="doLogout">
                    <svg class="header__dropdown-menu-icon" width="21" height="21" viewBox="0 0 21 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.077 12.3082C13.873 12.3082 13.6773 12.3893 13.533 12.5335C13.3888 12.6778 13.3077 12.8735 13.3077 13.0775V17.6935C13.3075 17.8974 13.2264 18.093 13.0822 18.2373C12.9379 18.3815 12.7424 18.4626 12.5384 18.4628H3.3065C3.10247 18.4628 2.90679 18.3817 2.76251 18.2375C2.61824 18.0932 2.53718 17.8975 2.53718 17.6935V2.307C2.53718 2.10296 2.61824 1.90728 2.76251 1.76301C2.90679 1.61873 3.10247 1.53768 3.3065 1.53768H12.5384C12.7424 1.53786 12.9379 1.61897 13.0822 1.76321C13.2264 1.90745 13.3075 2.10302 13.3077 2.307V6.92294C13.3077 7.12698 13.3888 7.32266 13.533 7.46693C13.6773 7.61121 13.873 7.69226 14.077 7.69226C14.2811 7.69226 14.4767 7.61121 14.621 7.46693C14.7653 7.32266 14.8464 7.12698 14.8464 6.92294V2.307C14.8457 1.6951 14.6023 1.10845 14.1696 0.675763C13.7369 0.24308 13.1503 -0.000296104 12.5384 -0.000968092H3.3065C3.00331 -0.00179236 2.70296 0.0575462 2.42285 0.173611C2.14275 0.289676 1.88845 0.46016 1.67469 0.67519C1.24327 1.1089 1.0003 1.69526 0.998535 2.307V17.6935C1.0003 18.3052 1.24327 18.8916 1.67469 19.3253C1.88845 19.5403 2.14275 19.7108 2.42285 19.8269C2.70296 19.9429 3.00331 20.0023 3.3065 20.0014H12.5384C13.1503 20.0008 13.7369 19.7574 14.1696 19.3247C14.6023 18.892 14.8457 18.3054 14.8464 17.6935V13.0775C14.8464 12.8735 14.7653 12.6778 14.621 12.5335C14.4767 12.3893 14.2811 12.3082 14.077 12.3082Z"
                              fill="#666666" fill-opacity="0.6"/>
                        <path d="M20.9415 10.2941C20.9994 10.1534 21.0145 9.99879 20.9849 9.84959C20.9552 9.7004 20.8822 9.56329 20.7748 9.45549L17.698 6.37904C17.5529 6.23891 17.3586 6.16136 17.1569 6.16312C16.9552 6.16487 16.7622 6.24578 16.6196 6.38842C16.4769 6.53105 16.396 6.72401 16.3943 6.92572C16.3925 7.12744 16.4701 7.32177 16.6102 7.46687L18.3742 9.23093H6.38358C6.17954 9.23093 5.98386 9.31198 5.83959 9.45625C5.69531 9.60053 5.61426 9.79621 5.61426 10.0002C5.61426 10.2043 5.69531 10.4 5.83959 10.5442C5.98386 10.6885 6.17954 10.7696 6.38358 10.7696H18.3742L16.6102 12.5336C16.5367 12.6046 16.4781 12.6895 16.4378 12.7833C16.3975 12.8772 16.3762 12.9782 16.3754 13.0803C16.3745 13.1825 16.3939 13.2838 16.4326 13.3783C16.4713 13.4729 16.5284 13.5588 16.6007 13.631C16.6729 13.7032 16.7588 13.7603 16.8533 13.799C16.9479 13.8377 17.0492 13.8572 17.1513 13.8563C17.2535 13.8554 17.3544 13.8342 17.4483 13.7939C17.5422 13.7535 17.627 13.6949 17.698 13.6215L20.7748 10.5447C20.8464 10.4729 20.903 10.3878 20.9415 10.2941Z"
                              fill="#666666" fill-opacity="0.6"/>
                    </svg>
                    Выход
                </a>
            </div>
        </div>

    </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: "NavbarTop",
    props: {
        isMenuOpened: Boolean,
    },
    computed: {
      ...mapGetters([
        'getUser',
        'getCurrentProfile'
      ])
    },
    methods: {
      ...mapActions(['logout']),
      doLogout() {
        this.logout().then(() => {
          this.$router.push('/login');
        });
      },
      toggleMenu() {
          this.$emit('menu')
      }
    }
  }
</script>

<style scoped lang="scss">
    .header-user__avatar-img {
        height: 100%;
        width: 100%;
        border-radius: 6px;
    }

    .k-navbar__toggler-icon {
        display: flex;
        align-items: center;
        width: 45px;
        height: 30px;
        padding: 0;
        background-color: transparent;
        border: 0;
        outline: 0;
        margin: 0 15px;
    }

    .k-navbar__toggler-icon span {
        position: relative;
        width: 40px;
        height: 6px;
        background-color: #fff;
        border-radius: 3px;
    }

    .k-navbar__toggler-icon span::after,
    .k-navbar__toggler-icon span::before {
        content: '';
        position: absolute;
        left: 0;
        height: 6px;
        background-color: #fff;
        border-radius: 3px;
        transition-delay: 0s, .4s;
    }

    .k-navbar__toggler-icon span::before {
        top: -12px;
        width: 35px;
        transition: top .4s ease, transform .4s ease;
    }

    .k-navbar__toggler-icon span::after {
        bottom: -12px;
        width: 45px;
        transition: bottom .4s ease, transform .4s ease;
    }

    .k-navbar__toggler-icon.active span::before {
        top: 0;
        width: 45px;
        transform: rotate(-45deg);
    }

    .k-navbar__toggler-icon.active span::after {
        bottom: 0;
        width: 45px;
        transform: rotate(45deg);
    }

    .k-navbar__toggler-icon.active span {
        width: 0;
    }
</style>
